import * as React from "react";
import {View, ViewContent, ViewHeader, ViewMain} from "../controls/View";
import {RootStore} from "../../stores/RootStore";
import {Card, CardActions, CardHeader} from "../controls/Card";
import {observer} from "mobx-react";
import {Order} from "../../model/Order";
import {
    OrderDetailsCardContent, OrderNewerVersionContent, OrderPinCardContent,
    OrderStatusCardHeader
} from "./OrderCommon";
import {Button} from "../controls/Button";
import {FormattedMessage, injectIntl} from 'react-intl';

@observer
export class OrderClearingFailure extends React.Component<OrderClearingFailure.Props, undefined> {

    constructor(props: OrderClearingFailure.Props) {
        super(props);
    }

    render() {
        let promisedOrder = this.props.store.viewOrder.order;
        const {intl} = this.props;
        return (
            <View className="clesy-order-clearing-failure" active={this.props.active}>
                { promisedOrder && (
                    <ViewMain>
                        <ViewHeader>
                            {promisedOrder.pending && <h1>{intl.formatMessage({id:"orderClearingFailure.pendingHeader"})}</h1>}
                            {promisedOrder.rejected && <h1>{promisedOrder.reason.toString()}</h1>}
                            {promisedOrder.fulfilled && <h1><FormattedMessage id="orderClearingFailure.fulfilled" values={{orderNumber:promisedOrder.value.orderNumber}}/></h1>}
                            <div className="cancel-button">
                                <Button onClick={this.props.onCancel}><FormattedMessage id="orderClearingFailure.buttonCancel"/></Button>
                            </div>
                        </ViewHeader>
                        <ViewContent>
                            { promisedOrder.fulfilled && this.renderOrder(promisedOrder.value) }
                        </ViewContent>
                    </ViewMain>
                )}
            </View>
        );
    }

    renderOrder(order: Order) {
        return (
            <Card>
                <OrderStatusCardHeader order={order}/>
                <CardHeader>
                    <div className="error-message">
                        <FormattedMessage id="orderClearingFailure.orderStatus.errorMessage"/>
                    </div>
                </CardHeader>
                <CardActions>
                    { order.needsPayment() && (
                        <Button primary={true} onClick={e => this.props.onPayOrder(order)}><i>payment</i>
                            <FormattedMessage id="orderClearingFailure.orderStatus.button"/></Button>
                    )}
                    { order.bill && order.bill.documentUrl &&
                    <a href={order.bill.documentUrl} className="button" target="_blank"><i>receipt</i><FormattedMessage id="orderClearingFailure.orderStatus.a"/></a> }
                </CardActions>
                <OrderDetailsCardContent order={order}/>
            </Card>
        );
    }
}

export namespace OrderClearingFailure {
    export interface Props {
        active: boolean;
        store: RootStore;
        onPayOrder: (order: Order) => void;
        onCancel: () => void;
        intl: any;
    }


}
export default injectIntl(OrderClearingFailure)

